module.exports = __webpack_public_path__ + "static/media/PP2-5K.890a3dce.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Paper2/PP2-5K.png
// module id = 250
// module chunks = 0